import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { Nav, NavLink, NavItem } from "reactstrap";
import ProfileForm from '../../Shared/ProfileForm';
import {updateUserProfile} from '../../api/dashboardApi';

const ViewUser = () => {
    const [activeTab, setActiveTab] = useState(1);
    const dispatch = useDispatch();
	const state = useSelector(state => state) || {};
    const {authenticationReducer: {userProfile = {}} = {}, dashboardReducer: {updatingFaculty} = {}} = state;

    return (
        <Fragment>
            <div className="section-body">
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center ">
                        <div className="header-action">
                            <h1 className="page-title">View User profile</h1>
                            <ol className="breadcrumb page-breadcrumb">
                                <li className="breadcrumb-item"><span>St. Andrews College</span></li>
                                <li className="breadcrumb-item active" aria-current="page">View user profile</li>
                            </ol>
                        </div>
                        <Nav tabs className="page-header-tab">
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === 1 })}
                                    onClick={() => setActiveTab(1)}
                                >
                                    Information
                            </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === 2 })}
                                    onClick={() => setActiveTab(2)}
                                >
                                    Upload Documents
                                </NavLink>
                                
                            </NavItem>
                            
                        </Nav>
                    </div>
                </div>
            </div>
            <ProfileForm
                isStaffLogin={true}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                updateUserProfile={(e, cb) => dispatch(updateUserProfile(e, cb))}
                userProfile={userProfile}
                updatingFaculty={updatingFaculty}
            />
        </Fragment>
    );
}

export default ViewUser;